/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_age_mini = /** @type {(inputs: {}) => string} */ () => {
	return `Minimální věk`
};

const da_attributes_age_mini = /** @type {(inputs: {}) => string} */ () => {
	return `Age Mini`
};

const de_attributes_age_mini = /** @type {(inputs: {}) => string} */ () => {
	return `Age Mini`
};

const en_attributes_age_mini = /** @type {(inputs: {}) => string} */ () => {
	return `Age Mini`
};

const es_attributes_age_mini = /** @type {(inputs: {}) => string} */ () => {
	return `Age Mini`
};

const fr_attributes_age_mini = /** @type {(inputs: {}) => string} */ () => {
	return `Age Mini`
};

const hu_attributes_age_mini = /** @type {(inputs: {}) => string} */ () => {
	return `Age Mini`
};

const it_attributes_age_mini = /** @type {(inputs: {}) => string} */ () => {
	return `Age Mini`
};

const nl_attributes_age_mini = /** @type {(inputs: {}) => string} */ () => {
	return `Age Mini`
};

const pl_attributes_age_mini = /** @type {(inputs: {}) => string} */ () => {
	return `Wiek Mini`
};

const pt_attributes_age_mini = /** @type {(inputs: {}) => string} */ () => {
	return `Age Mini`
};

const sv_attributes_age_mini = /** @type {(inputs: {}) => string} */ () => {
	return `Ålder Mini`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_age_mini = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_age_mini(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_age_mini", locale)
	if (locale === "cs") return cs_attributes_age_mini(inputs)
	if (locale === "da") return da_attributes_age_mini(inputs)
	if (locale === "de") return de_attributes_age_mini(inputs)
	if (locale === "en") return en_attributes_age_mini(inputs)
	if (locale === "es") return es_attributes_age_mini(inputs)
	if (locale === "fr") return fr_attributes_age_mini(inputs)
	if (locale === "hu") return hu_attributes_age_mini(inputs)
	if (locale === "it") return it_attributes_age_mini(inputs)
	if (locale === "nl") return nl_attributes_age_mini(inputs)
	if (locale === "pl") return pl_attributes_age_mini(inputs)
	if (locale === "pt") return pt_attributes_age_mini(inputs)
	return sv_attributes_age_mini(inputs)
};
export { attributes_age_mini as "attributes.age_mini" }